"use strict";
/*
 * Created on 12 03 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Wrapper object to hold computed values of vendor allowance for single product.
 *
 * @author JMe
 */


var VendorAllowanceBonus =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(VendorAllowanceBonus, _DomainObject_1$Domai);

  /**
   * @param productId the id of internal product
   * @param withBackBonus computed value with back bonus
   * @param withoutBackBonus computed value without bonus
   */
  function VendorAllowanceBonus(productId, withBackBonus, withoutBackBonus) {
    var _this;

    _classCallCheck(this, VendorAllowanceBonus);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VendorAllowanceBonus).call(this));
    _this.productId = productId;
    _this.withBackBonus = withBackBonus;
    _this.withoutBackBonus = withoutBackBonus;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to vendor allowance bonus.
   */


  _createClass(VendorAllowanceBonus, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new VendorAllowanceBonus(mat.productId, mat.withBackBonus, mat.withoutBackBonus);
    }
  }]);

  return VendorAllowanceBonus;
}(DomainObject_1.DomainObject);

exports.VendorAllowanceBonus = VendorAllowanceBonus; // tslint:disable-next-line:member-ordering

VendorAllowanceBonus.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(VendorAllowanceBonus.name);
  return {
    productId: builder.id('productId'),
    withBackBonus: builder.opt(builder.bigNum('withBackBonus')),
    withoutBackBonus: builder.opt(builder.bigNum('withoutBackBonus'))
  };
}();